module.exports = __webpack_public_path__ + "static/2_1-a61a8a88171e6f474f9d479933bf1a6b.jpg";